import { render, staticRenderFns } from "./AddUnion.vue?vue&type=template&id=20326703&scoped=true&"
import script from "./AddUnion.vue?vue&type=script&lang=js&"
export * from "./AddUnion.vue?vue&type=script&lang=js&"
import style0 from "./AddUnion.vue?vue&type=style&index=0&id=20326703&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20326703",
  null
  
)

export default component.exports